interface SystemTitleSectionProps {
  line1High: string
  line2Primary: string
  line1HighMobileA: string
  line1HighMobileB: string
  line2PrimaryMobileA: string
  line2PrimaryMobileB: string
}

export function SystemTitleSection({
  line1High,
  line2Primary,
  line1HighMobileA,
  line1HighMobileB,
  line2PrimaryMobileA,
  line2PrimaryMobileB,
}: SystemTitleSectionProps) {
  return (
    <section id="system-title" data-marketing-section="" className="w-full bg-qb-bg pt-14 pb-14 lg:pt-[104px] lg:pb-24 tracking-[-0.6px]">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0">
        <h2 className="text-center font-bold text-[28px] lg:text-[40px] leading-[1.4] lg:leading-[1.2]">
          <span className="block text-qb-text-high">
            <span className="hidden lg:inline">{line1High}</span>
            <span className="lg:hidden">
              {line1HighMobileA}
              <br aria-hidden />
              {line1HighMobileB}
            </span>
          </span>
          <span className="block mt-1 lg:mt-2.5 text-qb-primary">
            <span className="hidden lg:inline">{line2Primary}</span>
            <span className="lg:hidden">
              {line2PrimaryMobileA}
              <br aria-hidden />
              {line2PrimaryMobileB}
            </span>
          </span>
        </h2>
      </div>
    </section>
  )
}
